import React, { FunctionComponent } from "react"
import { CircularProgress, Button } from "@material-ui/core"
import classnames from "classnames"
import styles from "./LoadingButton.module.scss"

interface LoadingButtonProps {
    loading: boolean
    disabled: boolean
    text: string
    buttonId: string
    onClick?: () => any
    submit?: boolean
    form?: string
}

export const LoadingButton: FunctionComponent<LoadingButtonProps> = ({
    text,
    loading,
    disabled,
    buttonId,
    onClick = () => {},
    submit = false,
    form = ""
}) => {
    return (
        <div className={styles.Container}>
            <Button
                data-testid={buttonId}
                variant={"contained"}
                color={"primary"}
                onClick={onClick}
                disabled={disabled}
                type={submit ? "submit" : "button"}
                form={form}
            >
                <span
                    className={classnames({
                        [styles.Hidden]: loading
                    })}
                >
                    {text}
                </span>
            </Button>
            {loading && (
                <CircularProgress
                    data-testid={`${buttonId}-spinner`}
                    size={24}
                    color={"secondary"}
                    className={styles.Spinner}
                />
            )}
        </div>
    )
}
